import { apiStatusConstants } from "../../global/constants/apiStatusConstants";
import { types } from "../actions";

const initialState = {
  // Common camera onboarding states
  cameraId: "",
  fovIds: [],
  fovSelected: [],
  companionDevice: { name: "", id: "", qrcode: "" },
  siteObject: { name: "", id: "" },
  floorObject: { name: "", id: "", imageid: "", imageurl: "" },
  areaObject: { name: "", id: "" },
  subareaObject: { name: "", id: "" },
  cameraName: "",
  streamInfo: [{ fovId: "", name: "", url: "", rtspPath: "", encoding: "", resolution: "", enableSearch: false }],
  companionListByCamera: [],
  companionLoading: false,
  companionError: null,
  selectedCamQR: "",
  camPosition: { top: 0, left: 0 },
  unpairedCamDetails: {
    name: "",
    id: "",
    uid: "",
    customdata: { cameralocation: { top: 0, left: 0 } },
  },
  calculatedAvailabilityCount: 0,
  calculatedStreamCount: 0,
  disableButton: true,
  camDetails: {},
  // Manual add camera states
  username: "",
  password: "",
  host: "",
  port: "",
  manualAddResponse: [],
  rtspUrl: "",
  paringStatus: false,
  // API status
  manualAddStatus: apiStatusConstants.NOT_INTIATED,
  metaDataUpdateStatus: apiStatusConstants.NOT_INTIATED,
  modalOpenObj: {},
  isValidated: true,
  userFullName: "",
  userPassword: "",
  userHostName: "",
  userPortName: "",
  manualApiResponse: [],
  currentStep: 0,
  manualStepTrigger: 0,
};

const cameraOnboardingReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_COMPANION_LIST_BY_CAMERA_REQUEST:
      return { ...state, companionLoading: true, companionError: null };
    case types.FETCH_COMPANION_LIST_BY_CAMERA_SUCCESS:
      return {
        ...state,
        companionLoading: false,
        companionListByCamera: action.payload,
      };
    case types.FETCH_COMPANION_LIST_BY_CAMERA_FAILURE:
      return {
        ...state,
        companionLoading: false,
        companionError: action.payload,
      };
    case types.SET_CAMERA_QR:
      return {
        ...state,
        selectedCamQR: action.value,
      };
    case types.FETCH_COMPANION:
      return {
        ...state,
        companionDevice: action.value,
      };
    case types.SELECT_ENCODES:
      return {
        ...state,
        streamInfo: action.value,
      };
    case types.ADD_RTSP_URL:
      return {
        ...state,
        rtspUrl: action.value,
      };
    case types.MODAL_OPEN:
      return {
        ...state,
        modalOpenObj: action.value,
      };
    case types.SET_ONBOARDING_STEP:
      return {
        ...state,
        currentStep: action.payload,
      };
    case types.ADD_MANUAL_CAMERA_SUCCESS_RES:
      return {
        ...state,
        manualAddResponse: action.payload,
      };
    case types.ADD_MANUAL_CAMERA_SUCCESS:
      return {
        ...state,
        manualAddStatus: apiStatusConstants.SUCCESS,
        manualStepTrigger: state.manualStepTrigger + 1,
      };
    case types.ADD_MANUAL_CAMERA_FAILURE:
      return {
        ...state,
        manualAddStatus: apiStatusConstants.FAILURE,
      };
    case types.GET_FOVIDS:
      return {
        ...state,
        fovIds: action.value,
      };
    case types.SELECTED_CAMERA_UPDATED: {
      return {
        ...state,
        cameraName: action.value,
      };
    }
    case types.FETCH_SITE:
      return {
        ...state,
        siteObject: action.value,
      };
    case types.FETCH_FLOOR:
      return {
        ...state,
        floorObject: action.value,
      };
    case types.FETCH_AREA:
      return {
        ...state,
        areaObject: action.value,
      };
    case types.FETCH_SUBAREA:
      return {
        ...state,
        subareaObject: action.value,
      };
    case types.SET_CAM_POSITION: {
      return {
        ...state,
        camPosition: {
          ...state.camPosition,
          ...{
            top: action.value?.position.top,
            left: action.value?.position?.left,
          },
        },
      };
    }
    case types.SET_UNPAIRED_CAM_DETAILS: {
      return {
        ...state,
        unpairedCamDetails: {
          ...state.unpairedCamDetails,
          ...(action.value?.qrcode && {
            name: action.value?.qrcode,
            id: action.value?.qrcode,
            uid: action.value?.qrcode,
          }),
          customdata: {
            ...state.unpairedCamDetails.customdata,
            cameralocation: {
              ...state.unpairedCamDetails.customdata.cameralocation,
              ...(action.value?.position && {
                top: action.value?.position?.top,
                left: action.value?.position?.left,
              }),
            },
          },
        },
      };
    }
    case types.SET_SELECTED_COMPANION_FOV_STREAM_COUNTS:
      return {
        ...state,
        calculatedAvailabilityCount:
          action.payload.selectedCompanionFovStreamAvailabilityCount,
        calculatedStreamCount: action.payload.selectedCompanionFovStreamCount,
      };
    case types.DISABLE_NEXT_BUTTON: {
      return {
        ...state,
        disableButton: action.payload,
      };
    }
    case types.SET_CAM_DETAILS: {
      return {
        ...state,
        camDetails: action.value,
      };
    }
    case types.SET_USER_NAME: {
      return {
        ...state,
        userFullName: action.value,
      };
    }
    case types.SET_PASSWORD: {
      return {
        ...state,
        userPassword: action.value,
      };
    }
    case types.SET_HOST_NAME: {
      return {
        ...state,
        userHostName: action.value,
      };
    }
    case types.SET_PORT_NAME: {
      return {
        ...state,
        userPortName: action.value,
      };
    }
    case types.SET_IS_VALID: {
      return {
        ...state,
        isValidated: action.value,
      };
    }
    case types.SET_MANUAL_API_RESPONSE: {
      return {
        ...state,
        manualApiResponse: action.value,
      };
    }
    case types.CLEAR_ONBOARDING_FIELDS: {
      const fields = action.payload;
      let newState = { ...state };
      fields.forEach((field) => {
        if (field in initialState) {
          newState[field] = initialState[field];
        }
      });
      return newState;
    }
    case types.RESET_ONBOARD_CAMERA: {
      return { 
        ...initialState, 
        streamInfo: [{ ...initialState.streamInfo[0] }],
      };
    }
    default:
      return state;
  }
};

export default cameraOnboardingReducer;
